<template>
  <div>
    <v-dialog v-model="model" class="tw-max-w-[620px] tw-w-full custom-info-modal">
      <v-card>
        <div class="tw-bg-white tw-h-[650px]">
          <div class="tw-m-2 tw-bg-black tw-opacity-90 tw-h-[634px] tw-px-8 tw-py-32">
            <div class="tw-rounded tw-bg-white tw-p-[15px] tw-min-h-24">
              <div>
                <div class="tw-flex tw-justify-between tw-items-center">
                  <h3 class="tw-font-kanit tw-text-sm tw-capitalize">{{ infoHeading }}</h3>
                  <v-icon
                    @click="$emit('toggleInfoDialog')"
                    size="18px"
                    class="tw-ml-[2px] !tw-text-black tw-cursor-pointer"
                    icon=" fa fa-close"
                  ></v-icon>
                </div>
                <p class="tw-font-kanit tw-text-sm tw-font-extralight tw-mt-1">{{ infoDetails }}</p>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
defineProps(['infoDetails', 'infoHeading']);
const model = defineModel();
</script>

<style>
.custom-info-modal .v-overlay__scrim {
  @apply !tw-bg-white !tw-opacity-100 sm:!tw-bg-black sm:!tw-opacity-30;
}
.custom-info-modal .v-card {
  @apply !tw-shadow-none;
}
</style>
